
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { makeWhatsappLink, normalizeHttp } from "../utils";
import { formatPhone } from "../wmc/format.utils";

const AppConfigStore = namespace("AppConfig");

@Component({
  name: "MainFooter",
})
export default class MainFooter extends Vue {
  @AppConfigStore.Getter
  private getConfigsVisuais!: any;

  @AppConfigStore.Getter
  private getLinksRedesSociais!: any;

  @AppConfigStore.Getter
  getListaPaginasCustom!: any;

  @AppConfigStore.State
  aplicativo!: any;

  private logo = require("@/assets/Logo-WMC.svg");

  get mobileViewport() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  capitalize(text: string) {
    return text.replace(/\w\S*/g, (w) =>
      w.replace(/^\w/, (c) => c.toUpperCase())
    );
  }

  get fale_conosco_path() {
    return this.getListaPaginasCustom
      .find((x) => x.tipoPagina == 2)
      ?.nome?.replace(/\s/g, "_")
      .toLowerCase();
  }

  get formattedPhoneNumbers() {
    return {
      fone: formatPhone(this.getConfigsVisuais.visual.fone || ""),
      celular: formatPhone(this.getConfigsVisuais.visual.celular || ""),
    };
  }

  private redesSociaisMapper = {
    facebook: "mdi-facebook",
    instagram: "mdi-instagram",
    twitter: "mdi-twitter",
    youtube: "mdi-youtube",
    tiktok: require("@/assets/tiktok.svg"),
  };

  get titleAlignment() {
    if (this.$vuetify.breakpoint.smAndDown) {
      return {
        seguranca: "text-center",
        atendimento: "text-center",
      };
    }
    return {
      seguranca: "text-end",
      atendimento: "text-start",
    };
  }

  get iconsAlignment() {
    if (this.$vuetify.breakpoint.smAndDown) {
      return {
        seguranca: "justify-center",
        atendimento: "justify-center",
      };
    }
    return {
      seguranca: "justify-end",
      atendimento: "justify-start",
    };
  }

  get hasPhoneNumbers() {
    return (
      !!this.getConfigsVisuais.visual?.fone ||
      this.getConfigsVisuais.visual?.celular ||
      ""
    );
  }

  get getWhatsappLink() {
    return makeWhatsappLink(this.getConfigsVisuais.visual?.celular);
  }

  get getLinksSocial() {
    return Object.keys(this.getLinksRedesSociais).reduce((result, current) => {
      if (current === "id" || !this.getLinksRedesSociais[current]) {
        return result;
      }

      return [
        ...result,
        {
          link: normalizeHttp(this.getLinksRedesSociais[current]),
          icon: this.redesSociaisMapper[current],
          svg:
            current === "tiktok" ? this.redesSociaisMapper[current] : undefined,
        },
      ];
    }, [] as Array<any>);
  }
}
